// eslint-disable-next-line import/no-extraneous-dependencies
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  csrfToken: null,
  csrfHeader: null
};

export const initialData = createSlice({
  name: 'initialData',
  initialState,
  reducers: {
    updateCsrf: (state, action) => {
      state.csrfToken = action.payload.csrfToken;
      state.csrfHeader = action.payload.csrfHeader;
    }
  }
});

// Action creators are generated for each case reducer function
export const { updateCsrf } = initialData.actions;

export default initialData.reducer;
